import getYear from './getYear';
export default function(year, month, day) {
	month = month - 1; // 0-11 in JavaScript
	var tmpDate = new Date(year, month, day);
	if (getYear(tmpDate.getYear()) == year && month == tmpDate.getMonth() && day == tmpDate.getDate()) return true;
	else return false;
}
